import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";




const Hadear = () => {
  const [toggle, setToggle] = useState(false);

  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

        // "service_oumku8k",
        // "template_esy4tqm",
        // "#myForm",
        // "8i7i_APkS7sZ9CqPl"
      )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };


  return (
    <>
     
    
      <header className="header-area stricky" style={{ backgroundColor: "white" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="outer-box clearfix">
                <div className="logo">
                  <Link to="/">
                    <img src="./assets/ply/ply.png" alt="Awesome Logo" style={{width:"90px", height:"90px"}} />
                    {/* ./assets/public/website/assets/images/Untitled design (12).png */}
                  </Link>
                </div>
                <nav className="main-menu">
                  <div className="navbar-header">
                    <button
                      id="mytogglebtn"
                      v
                      className="navbar-toggle collapsed"
                      data-toggle="collapse"
                      data-target="#menu"
                      onClick={closemenu}
                    >
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />

                    </button>
                  </div>
                  <div className="navbar-collapse collapse clearfix" id="menu" >
                    <ul className="navigation clearfix mt-lg-5" style={{ fontFamily: "'PT Serif', serif" }} >
                      <li className="current"  >
                        <Link to="/" onClick={closemenu} >
                          Home
                        </Link>
                      </li>
                      <li className="" >
                        <Link to="/overview" onClick={closemenu}>
                          Overview
                        </Link>
                      </li>
                      {/* <li className="dropdown">
                        <Link to="/about-us" onClick={closemenu}>About Us</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <li>
                            <Link to="/about-us" onClick={closemenu}>
                              About Us
                            </Link>
                          </li>

                          <li>
                            <Link to="/Mission" onClick={closemenu}>
                              Vision & Mission
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li> */}
                      <li className="dropdown">
                        <Link onClick={closemenu}>Our Products</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/flush-doors" onClick={closemenu}>
                              Flush Doors
                            </Link>
                          </li>
                          <li>
                            <Link to="/plywood" onClick={closemenu}>
                              Plywood
                            </Link>
                          </li>
                          <li>
                            <Link to="/block-boards" onClick={closemenu}>
                              Block Boards
                            </Link>
                          </li>
                          <li>
                            <Link to="/shuttering-ply" onClick={closemenu}>
                            Shuttering Ply
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>




                      {/* <li className="">
                        <Link to="/gallery" onClick={closemenu}>
                          Gallery
                        </Link>
                      </li> */}

                      <li className="">
                        <Link to="/blog" onClick={closemenu}>
                          Blog
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/gallery" onClick={closemenu}>
                        Gallery
                        </Link>
                      </li>
                      {/* <li className="">
                        <Link to="/careers" onClick={closemenu}>
                          Careers
                        </Link>
                      </li> */}

                      <li className="dropdown">
                        <Link onClick={closemenu}>More</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <a to="/" onClick={closemenu}>
                              Download
                            </a>
                            <ul
                              style={
                                showAbout
                                  ? { display: "block" }
                                  : { display: "none" }
                              }
                            >

                              <li>
                                <a href="./assets/ply/ASPL COMPANY PROFILE.PDF" target="_blank" onClick={closemenu}>
                                  Company Profile
                                </a>
                              </li>
                              <li>
                                <a href="./assets/ply/WARRANTY T&C.PDF" target="_blank" onClick={closemenu}>
                                  Warranty T&C
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li>
                            <Link to="/plywood" onClick={closemenu}>
                              Wood Work
                            </Link>
                            <ul
                              style={
                                showAbout
                                  ? { display: "block" }
                                  : { display: "none" }
                              }
                            >

                              <li>
                                <a href="./assets/ply/ASPL COMPANY PROFILE.PDF" target="_blank" onClick={closemenu}>
                                  Company Profile
                                </a>
                              </li>
                              <li>
                                <a href="./assets/ply/TAKSHANAM_furniture collection-22-23.PDF" target="_blank" onClick={closemenu}>
                                  Furniture Collection
                                </a>
                              </li>
                            </ul>
                          </li>

                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>


                      <li className="">
                        <Link to="/contact-us" onClick={closemenu}>
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>


    </>
  )
}

export default Hadear